﻿export enum SortType {
    DESC = 0,
    ASC = 1
}